import type { AlertRecord } from '../api/useAllAlerts'

/** Drops a deleted alert from a cached list without waiting on a refetch. */
export const removeAlertById = (
  alerts: AlertRecord[] | undefined,
  alertId: string,
): AlertRecord[] => (alerts ?? []).filter((alert) => alert.id !== alertId)

/** Flips an alert's enabled state in a cached list without waiting on a refetch. */
export const setAlertEnabled = (
  alerts: AlertRecord[] | undefined,
  alertId: string,
  enabled: boolean,
): AlertRecord[] =>
  (alerts ?? []).map((alert) => (alert.id === alertId ? { ...alert, enabled } : alert))
